import { ReactNode, useEffect, useState } from "react";
import { OrderDetail } from "../../types";
import { useParams } from "react-router-dom";
import OrderService from "../../service/OrderService";
import { getReducedCartItems } from "../../utils/CartUtils";
import { OrderContext } from "./OrderContext";

const OrderProvider = ({ children }: { children: ReactNode }) => {
  const { orderId } = useParams();

  const [orderDetail, setOrderDetail] = useState<OrderDetail>();
  const [isOrderLoaded, setIsOrderLoaded] = useState(false);

  useEffect(() => {
    if (!orderId) {
      return;
    }
    setIsOrderLoaded(false);
    OrderService.getOrder(orderId).then((order) => {
      setOrderDetail(order.data.data);
      setIsOrderLoaded(true);
    });
  }, [orderId]);

  return (
    <OrderContext.Provider
      value={{
        orderDetail: orderDetail,
        reducedOrderItems: getReducedCartItems(
          orderDetail?.pricing.comboItems ?? []
        ),

        isOrderLoaded,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};

export default OrderProvider;
